import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { appPath } from '../constants/appBasePath';
import DashboardLayout from '../components/DashboardLayout';

export default function NotFoundPage() {
  return (
    <DashboardLayout>
      <div className="flex min-h-[calc(100vh-73px)] items-center justify-center px-6 py-16">
        <div className="w-full max-w-md rounded-[10px] border border-theme-border bg-surface px-10 py-8 text-center">
          <ExclamationCircleIcon className="mx-auto mb-4 h-10 w-10 text-gold-500" />
          <p className="mb-1 text-sm font-semibold tracking-widest text-gold-500 uppercase">
            404
          </p>
          <h1 className="mb-2 text-2xl font-semibold text-on-surface">
            Page not found
          </h1>
          <p className="mb-8 text-base text-on-surface-tertiary">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <a
            href={appPath('/')}
            className="inline-block rounded-none bg-gold-500 px-8 py-3 text-base font-semibold text-ink transition-colors hover:bg-gold-600"
          >
            Back to start
          </a>
        </div>
      </div>
    </DashboardLayout>
  );
}
